import React from 'react';
import './InitializationLoader.css';

interface InitializationState {
  accounts: boolean;
  products: boolean;
  productCategories: boolean;
  instruments: boolean;
  sseConnection: boolean;
  isComplete: boolean;
  error: string | null;
}

interface InitializationLoaderProps {
  initializationState: InitializationState;
  onRetry: () => void;
}

export const InitializationLoader: React.FC<InitializationLoaderProps> = ({
  initializationState,
  onRetry
}) => {
  return (
    <div className="initialization-overlay">
      <div className="initialization-content">
        <h2 className="initialization-title">Initializing Trade Room...</h2>
        <div className="initialization-steps">
          <div className={`init-step ${initializationState.accounts ? 'complete' : 'pending'}`}>
            <span className="step-icon">{initializationState.accounts ? '✅' : '⏳'}</span>
            <span className="step-text">Loading accounts</span>
          </div>
          <div className={`init-step ${initializationState.products ? 'complete' : 'pending'}`}>
            <span className="step-icon">{initializationState.products ? '✅' : '⏳'}</span>
            <span className="step-text">Loading products</span>
          </div>
          <div className={`init-step ${initializationState.productCategories ? 'complete' : 'pending'}`}>
            <span className="step-icon">{initializationState.productCategories ? '✅' : '⏳'}</span>
            <span className="step-text">Loading product categories</span>
          </div>
          <div className={`init-step ${initializationState.instruments ? 'complete' : 'pending'}`}>
            <span className="step-icon">{initializationState.instruments ? '✅' : '⏳'}</span>
            <span className="step-text">Loading instruments</span>
          </div>
          <div className={`init-step ${initializationState.sseConnection ? 'complete' : 'pending'}`}>
            <span className="step-icon">{initializationState.sseConnection ? '✅' : '⏳'}</span>
            <span className="step-text">Establishing real-time connection</span>
          </div>
        </div>
        {initializationState.error && (
          <div className="initialization-error">
            <p className="error-message">❌ Initialization failed: {initializationState.error}</p>
            <button 
              className="retry-button"
              onClick={onRetry}
            >
              Retry Initialization
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
